export default __webpack_public_path__ + "static/media/guide-to-front-on.f0987bc2.svg";